export default "__VITE_ASSET__BuKVJl9v__"